import d from 'dayjs';
import { getMonthName } from './calendar-info';

export const DATE_KEY = 'YYYY-MM-DD';

// dayjs .day(): 0 = Sunday ... 6 = Saturday
export const WEEKDAY_OPTIONS = [
  { value: 1, label: 'Mon' },
  { value: 2, label: 'Tue' },
  { value: 3, label: 'Wed' },
  { value: 4, label: 'Thu' },
  { value: 5, label: 'Fri' },
  { value: 6, label: 'Sat' },
  { value: 0, label: 'Sun' }
];
export const ALL_WEEKDAYS = WEEKDAY_OPTIONS.map(o => o.value);

export const toKey = date => d(date).format(DATE_KEY);
export const todayKey = () => toKey(d());
export const isPastKey = key =>
  d(key).startOf('day').isBefore(d().startOf('day'));

// Calendar entries come back from the API as ISO strings at UTC midnight
// (that is how the admin writes them), so slice the date part instead of
// converting through the browser timezone.
export const entryKey = entry =>
  typeof entry?.date === 'string' ? entry.date.slice(0, 10) : toKey(entry?.date);

export function normalizeRange(a, b) {
  if (!a) return { start: null, end: null };
  if (!b) return { start: a, end: a };
  return d(a).isAfter(d(b), 'day') ? { start: b, end: a } : { start: a, end: b };
}

export function datesBetween(start, end) {
  if (!start) return [];
  const { start: s, end: e } = normalizeRange(start, end || start);
  const out = [];
  const last = d(e);
  for (let cur = d(s); !cur.isAfter(last, 'day'); cur = cur.add(1, 'day')) {
    out.push(cur.format(DATE_KEY));
  }
  return out;
}

export function getTargetDates(range, daysOfWeek = ALL_WEEKDAYS) {
  return datesBetween(range?.start, range?.end).filter(key =>
    daysOfWeek.includes(d(key).day())
  );
}

export function getMonthsData(year, month, monthsToShow = 3, lang = 'en') {
  const months = [];
  for (let i = 0; i < monthsToShow; i++) {
    const cur = d(new Date(year, month, 1)).add(i, 'month');
    months.push({
      from: cur.startOf('month'),
      to: cur.endOf('month'),
      daysInMonth: cur.daysInMonth(),
      month: cur.month(),
      year: cur.year(),
      lang,
      monthName: `${getMonthName(cur.month(), lang)} ${cur.year()}`
    });
  }
  return months;
}

export function formatRangeLabel(range, format = 'D MMM YYYY') {
  if (!range?.start) return '';
  const s = d(range.start).format(format);
  if (!range.end || range.end === range.start) return s;
  return `${s} – ${d(range.end).format(format)}`;
}
